// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","890":"ee6e1832"}[chunkId] + "-" + {"218":"18c552085f4edf4312bb","691":"131f2ebf23e736c3a143","890":"a30efd8d2767f3b343b5"}[chunkId] + ".js";
};